document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('section:has(form[action="/cart/add"])');
  const form = section?.querySelector('form[action="/cart/add"]');
  const currencySymbol = '$';
  let variant_data = [];

  if (section && form) {
    const xData = section.getAttribute('x-data');
    const match = xData && xData.match(/ThemeSection_Product\(\s*({[\s\S]*})\s*\)$/);

    if (match && match[1]) {
      try {
        const product = (new Function('return ' + match[1]))().product;

        product.variants.forEach(variant => {
          variant_data.push({
            variant_id: variant.id,
            selling_plan: '',
            price: variant.price
          });

          (variant.selling_plan_allocations || []).forEach(plan => {
            variant_data.push({
              variant_id: variant.id,
              selling_plan: plan.selling_plan_id,
              price: plan.price
            });
          });
        });
      } catch (e) {
        console.error('❌ Error parsing x-data:', e);
      }
    }

    let timeoutId;

    const updatePrice = () => {
      clearTimeout(timeoutId); // Clear the previous timeout if any

      timeoutId = setTimeout(() => {
        const variantId = parseInt(form.querySelector('[name="id"]')?.value || '', 10);
        const sellingPlan = form.querySelector('[name="selling_plan"]')?.value || '';

        const match = variant_data.find(v =>
          v.variant_id === variantId &&
          v.selling_plan == sellingPlan
        );

        if (match) {
          const decimalPrice = (match.price / 100).toFixed(2);
          const target = form.querySelector('button.add-to-cart-btn span[x-html="formatMoney(current_price)"]');
          if (target) {
            target.innerText = `${currencySymbol}${decimalPrice}`;
          }
        }
      }, 100); // Delay update by 100ms
    };

    // Create a MutationObserver to observe value changes on inputs
    const observer = new MutationObserver(() => {
      updatePrice();
    });

    // Get all relevant inputs to observe
    const inputs = form.querySelectorAll('[name="id"], [name="selling_plan"], select');
    inputs.forEach(input => {
      // Observe changes in the value of the input fields
      observer.observe(input, { attributes: true, attributeFilter: ['value'] });
    });

    // Initial call to set the price when the page loads
    updatePrice();
  }
});